<template>
    <div class="visual-editor">
        <div v-if="isQueryValid === false" class="error-message">Not all fields has been filled</div>
        <template v-for="(entry, index) in visualQuery">
            <component v-if="entry.type"
                       :is="entry.type"
                       v-on:itemClosed="deleteItem(index)"
                       :key="index"
                       v-model="visualQuery[index]"/>
        </template>
        <h3 class="visual-editor__title">Add a rule :</h3>
        <div class="rules__icons">
            <div @click="addRule('People')" class="rules__icons-item">
                <div v-ripple class="icons-item__circle">
                    <v-img :src="require('@/assets/img/icons/people.svg')"></v-img>
                </div>
                <div class="icons-item__title">
                    People
                </div>
            </div>
            <div @click="addRule('Biographies')" class="rules__icons-item">
                <div v-ripple class="icons-item__circle">
                    <v-img :src="require('@/assets/img/icons/bio.svg')"></v-img>
                </div>
                <div class="icons-item__title">
                    Biographies
                </div>
            </div>
            <div @click="addRule('Messages')" class="rules__icons-item">
                <div v-ripple class="icons-item__circle">
                    <v-img :src="require('@/assets/img/icons/desc.svg')"></v-img>
                </div>
                <div class="icons-item__title">
                    Messages
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import People from "./People"
    import Biographies from "./Biographies"
    import Messages from "./Messages"

    export default {
        name: "CommunityManualVisualEditor",
        components: {
            People,
            Biographies,
            Messages
        },
        props: ['value', 'isQueryValid'],
        data: () => ({
            visualQuery: []
        }),
        methods: {
            deleteItem (idx) {
                this.visualQuery.splice(idx, 1)
            },
            addRule(type) {
                this.visualQuery.push({
                    type: type,
                    input: { value: null, type: null }
                })
            },
        },
        watch: {
            visualQuery: {
                handler(val, oldVal) {
                    this.$emit('input', val)
                },
                deep: true
            },
            value: {
                handler(val, oldVal) {
                    this.visualQuery = val
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
